import { render, staticRenderFns } from "./newFilter.vue?vue&type=template&id=3175b4fe&scoped=true&"
import script from "./newFilter.vue?vue&type=script&lang=js&"
export * from "./newFilter.vue?vue&type=script&lang=js&"
import style0 from "./newFilter.vue?vue&type=style&index=0&id=3175b4fe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3175b4fe",
  null
  
)

export default component.exports